import Message from "base/Message";
import TriggerUpdateModal from "modals/TriggerUpdateModal";

export function handleNavEvents() {
    $("body").on("click", ".js-logout", () => {
        Ajax.delete("adminUsers", "login").then(() => {
            window.location.href = "/";
        }).catch((e) => {
            new Message(e.message, "An error occurred");
        });
        return false;
    }).on("click", ".js-trigger-update", () => {
        let modal = new TriggerUpdateModal();
        modal.show();
        return false;
    });
}
